/**
 * Labstep
 *
 * @module components/EntityState/Form/ShowEdit/Description
 * @desc Update EntityState description
 */

import { fieldDescription } from 'labstep-web/components/EntityState/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Pre } from 'labstep-web/core/Pre';
import type React from 'react';
import type { EntityStateFormShowEditDescriptionProps } from './types';

export const EntityStateFormShowEditDescription: React.FC<
  EntityStateFormShowEditDescriptionProps
> = ({ entityState }) => (
  <ShowEditText
    entityName={entityState.entityName}
    entity={entityState}
    field={fieldDescription}
    placeholder="Add description"
  >
    <Pre>{entityState.description}</Pre>
  </ShowEditText>
);
